/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubDistrict } from '../../models/sub-district';

export interface ApiMasterProvinceGetSubDistrictByIdGet$Params {
  id?: number;
}

export function apiMasterProvinceGetSubDistrictByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterProvinceGetSubDistrictByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubDistrict>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterProvinceGetSubDistrictByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubDistrict>>;
    })
  );
}

apiMasterProvinceGetSubDistrictByIdGet.PATH = '/api/Master/Province/GetSubDistrictById';
